import { Injectable, inject } from '@angular/core';
import {
  HttpClient,
  HttpResourceRef,
  httpResource,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Id } from '@libs/shared/interfaces/id-dto.interface';
import { environment } from '@environments/environment';
import {
  EventVariableDto,
  EventVariableName,
} from '@api-types/dtos/event-variable.dto';
import { CreateEventVariableDto } from '@api-types/dtos/create-event-variable.dto';
import { UpdateEventVariableDto } from '@api-types/dtos/update-event-variable.dto';

@Injectable({
  providedIn: 'root',
})
export class EventVariableHttpClient {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = environment.api.url;

  getEventVariablesResource(): HttpResourceRef<EventVariableDto[]> {
    return httpResource<EventVariableDto[]>(
      () => `${this.baseUrl}/events/event-variables`,
      { defaultValue: [] },
    );
  }

  createEventVariable(createEventDto: CreateEventVariableDto): Observable<Id> {
    return this.http.post<Id>(
      `${this.baseUrl}/events/event-variables`,
      createEventDto,
    );
  }

  updateEventVariable(
    eventVariableId: string,
    updateEventDto: UpdateEventVariableDto,
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/events/event-variables/${eventVariableId}`,
      updateEventDto,
    );
  }

  deleteEventVariable(eventVariableId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/events/event-variables/${eventVariableId}`,
    );
  }

  getEventVariablesNames(): Observable<EventVariableName[]> {
    return this.http.get<EventVariableName[]>(
      `${this.baseUrl}/events/event-variables/names`,
    );
  }
}
